import React from "react";
import { Typography, Box, useMediaQuery, Button } from "@mui/material";

const ShowMoreLessText = ({
  text,
  maxLength = 150,
  isShowMore,
  setIsShowMore,
  style = {},
  showLess,
  showMore,
}) => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  if (typeof text !== "string") return null;

  return (
    <Box
    >
      <Box
        sx={{
          fontSize: !isSmallScreen ? "14px" : "0.9rem",
          mt: 1,
          wordBreak: "break-word",
          mb: 2,
          ...style,
        }}
      >
        {isShowMore ? text :`${text.slice(0, maxLength)}...` }

        {text.length > maxLength && (
          <Typography
            sx={{
        
              py:2,
              textTransform: "none",
              fontSize: "14px",
              textDecoration: "underline",

              cursor: "pointer",
            }}
            onClick={(e) => {
             e.stopPropagation()
              setIsShowMore();      
            }}
          >
            {isShowMore ? showLess || "Show Less" : showMore || "Show More"}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ShowMoreLessText;
